import en from "./en.json";
import it from "./it.json";

const communityMarketplace = { en, it };

export default communityMarketplace;
